import { createMask } from "imask";

export const createCpfMask = () => createMask({ mask: "000.000.000-00" });

export const createFiscalIdentifierMask = () =>
    createMask({
        mask: [
            {
                mask: "000.000.000-00",
            },
            {
                mask: "00.000.000/0000-00",
            },
        ],
    });
